import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Link as RouterLink } from 'react-router';

export function NotFoundPage() {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      gap={1.5}
      px={2}
      textAlign="center"
    >
      <Typography variant="h2" fontWeight={700} color="primary.main">
        404
      </Typography>
      <Typography variant="h6">Page not found</Typography>
      <Typography variant="body2" color="text.secondary" maxWidth={360}>
        The page you are looking for doesn&apos;t exist or has been moved.
      </Typography>
      <Button component={RouterLink} to="/dashboard" variant="contained" sx={{ mt: 2 }}>
        Back to dashboard
      </Button>
    </Box>
  );
}
